import { Link } from "react-router-dom";
import { ArrowUpRight, ShieldCheck } from "lucide-react";
import { BUSINESS } from "../../data/content";
import { Reveal } from "./Reveal";

export const AboutTeaser = () => {
  return (
    <section data-testid="about-teaser" className="surface-light py-24 lg:py-32">
      <div className="mx-auto w-[92%] max-w-[1280px] grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <Reveal>
            <span className="font-mono text-[12px] font-bold uppercase tracking-[0.25em] text-accent">Who We Are</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display font-bold tracking-tight leading-[0.98] text-4xl md:text-6xl text-fc-ink">
              Florida’s Class A HVAC Team.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-fc-ink2 text-lg max-w-xl">
              Led by owner {BUSINESS.owner}, F&amp;C Air Conditioning delivers professional HVAC
              for homes and businesses — backed by a Florida Class A contractor license and a
              commitment to honest, dependable work.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <Link
              to="/about"
              data-testid="about-teaser-link"
              className="group mt-8 inline-flex items-center gap-2 font-bold uppercase tracking-wide text-sm text-accent"
            >
              More About F&amp;C
              <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </Link>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="rounded-2xl border border-fc-sky/25 p-8 lg:p-10 shadow-[0_30px_70px_rgba(11,44,92,0.10)]" style={{ background: "linear-gradient(160deg,#f2f8ff,#e9f2fb)" }}>
            <div className="font-mono text-[12px] font-bold uppercase tracking-[0.25em] text-fc-navy">{BUSINESS.name}</div>
            <div className="mt-6 font-display text-4xl sm:text-5xl md:text-6xl font-bold text-fc-orange tracking-tight break-words">{BUSINESS.license}</div>
            <div className="mt-6 font-display text-2xl md:text-3xl font-semibold text-fc-navy leading-tight">
              Florida Class A<br />Air Conditioning Contractor
            </div>
            <div className="mt-6 flex items-center gap-2 font-mono text-sm font-bold uppercase tracking-widest text-fc-sky">
              <ShieldCheck size={16} /> Licensed &amp; Insured
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
